import { Component, inject } from '@angular/core';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { AuthenticatedDashboardComponent } from './authenticated-dashboard/authenticated-dashboard.component';
import { ToolOverlayComponent } from '../../molecules/tool-overlay/tool-overlay.component';
import { FooterComponent } from '../../molecules/footer/footer.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    AuthenticatedDashboardComponent,
    ToolOverlayComponent,
    FooterComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  readonly userStore = inject(ActiveUserStore);
}
